import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Envelope",
  "use": "Envelope-usage",
  "viewBox": "0 0 62 42",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 62 42\" id=\"Envelope\"><g fill-rule=\"evenodd\"><path d=\"M2 0h58a2 2 0 0 1 2 2v38a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm3 3a2 2 0 0 0-2 2v32a2 2 0 0 0 2 2h52a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5z\" /><path d=\"M1.897 1.86A.5.5 0 0 1 2.243 1h57.463a.5.5 0 0 1 .336.87L30.165 29 1.897 1.86zm6.422 1.713l21.846 20.814L53 3.573H8.319z\" /><path d=\"M3.19 41h55.596L36.195 20.97l-5.923 4.498-5.582-4.623L3.19 41zm6.781-2.573l16.592-14.874 3.71 3.662 3.699-3.712 17.401 14.924H9.971z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol